import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import * as Icon from 'react-feather';
import CustomLoader from '../common/Loader';
import MUIDataTable from "mui-datatables";
import { execGenericSP } from "../../services/utilService";
import { getDataSources } from "../../services/dataSourceService";

class ReportViewer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            //TODO: get Preload row data (report id/name) get other report config
            loading: true,
            DataSource_ID: 3,
            report: {
                Report_Name: this.props.rowData ? this.props.rowData[1] : 'Sample Report - ScreenedSubjects',
                /* DT Options Config */
                DTOptions: {
                    filter: true,
                    filterType: 'textField',
                    download: true,
                    print: false,
                    jumpToPage: true,
                    responsive: 'simple',
                    selectableRowsHeader: false,
                    selectableRows: 'none',
                    pagination: true,
                    rowsPerPageOptions: [10, 15, 30, 50, 100],
                    textLabels: {
                        body: {
                            noMatch: 'Sorry, No available Records!',
                        }
                    },
                },
                DTColumns: [],
                DTData: []
            }
        }
    }

    async componentDidMount() {
        //TODO: Get a Report's all Config, set states, exec SP and return result.
        const { data: DS } = await getDataSources();
        let DataSources = DS;
        var getConn = function (DataSource_ID = this.state.DataSource_ID) {
            const source = DataSources.find((source) => {
                return source.DataSource_ID === DataSource_ID;
            });
            return source.Connection_String;
        }

        let dataEl = {
            ResultSource_Content: 'Report.GetScreenedSubjects',
            Connection_String: getConn(this.state.DataSource_ID),
            jsonParameters: JSON.stringify([]),
        };
        const { data } = await execGenericSP(dataEl);
        let DTData = JSON.parse(data.data), report = this.state.report;
        report.DTColumns = Object.keys(DTData[0]);
        report.DTData = DTData;
        this.setState({ report, loading: false });
    }

    render() {
        const { report } = this.state;
        console.log(report);
        const loading = (<CustomLoader loading={this.state.loading} />);
        try {
            if (this.state.loading) { return loading }
            else {
                return (
                    <React.Fragment>
                        <header className='page-header page-header-dark bg-gradient-primary-to-secondary pb-10'>
                            <div className='container'>

                                <div className='page-header-content pt-4'>
                                    <div className='row align-items-center justify-content-between'>
                                        <div className='col-auto mt-4'>
                                            <h1 className='page-header-title'>
                                                <div className='page-header-icon'>
                                                    <Icon.TrendingUp />
                                                </div>
                                                Report Viewer
                                            </h1>
                                            <div className='page-header-subtitle'>
                                                MQUARK Reporting logistics.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </header>
                        <div className="container mt-n10">
                            <div className='card-body' id='customDT'>
                                <MUIDataTable
                                    key={'DTOptions'}
                                    title={report['Report_Name']}
                                    options={report['DTOptions']}
                                    columns={report['DTColumns']}
                                    data={report['DTData']}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                );
            }
        }
        catch (e) {
            console.error('Error loading Report Viewer: ', e);
            return (loading);
        }
    }
}

export default withRouter(ReportViewer);
